import React from "react";
import { MdArrowBackIos } from "react-icons/md";
import { useLocation,useNavigate } from "react-router-dom";
import { IoHome } from "react-icons/io5";

export default function Navbar() {
  const location = useLocation(); 
  const navigate = useNavigate();

  return (
    <div style={{ border: "1px solid #B3B3B3" }}>
      <div style={{ padding: "20px", display: "flex", alignItems: "center",justifyContent:"space-between" }}>
        {location.pathname === "/" ? ( // Check if the path is "/"
          <span style={{ fontSize: "18px", fontWeight: "bold" }}>VMS</span>
        ) : (
          <MdArrowBackIos size={25}color="black" onClick={()=>{navigate(-1)}} style={{ cursor: "pointer" }} />
        )}
        <div>
            <span size={25}color="black" onClick={()=>{navigate("/")}}><IoHome/></span>
        </div>
      </div>
    </div>
  );
}
